import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { FaPhoneAlt, FaLinkedin, FaHistory, FaHeart, FaQuestionCircle, FaBars } from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';
// Ajout des imports pour l'animation
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const { lang, switchLanguage, t } = useLanguage();
  const [expanded, setExpanded] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  // --- Logique Carrousel Partenaires (Droite) ---
  const partners = [
    { name: "Dell Platinum", src: "/images/dell.png" },
    { name: "Kyocera", src: "/images/kyocera.png" },
    { name: "Vembu", src: "/images/vembu.png" },
    { name: "PNY", src: "/images/pnyy.png" },
    { name: "Infortrend", src: "/images/infortrend.png" }
  ];
  const [partnerIndex, setPartnerIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPartnerIndex((prev) => (prev + 1) % partners.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [partners.length]);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 992;
      setIsDesktop(desktop);
      if (desktop) setExpanded(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggle = (nextShow, key) => {
    setOpenDropdown(nextShow ? key : null);
  };

  const handleScrollToSection = (path) => {
    setOpenDropdown(null);
    setExpanded(false);
    const hash = path.split('#')[1];
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 150);
    }
  };

  // Logique du logo de langue (Gauche)
  const langLogo = lang === 'fr' ? '/images/label-fr.png' : '/images/label-en.png';

  // --- Données des Menus (Inchangées) ---
  const aboutDropdown = [
    { name: t.header.aboutMenu.history, path: '/about#history', icon: <FaHistory /> },
    { name: t.header.aboutMenu.values, path: '/about#values', icon: <FaHeart /> },
    { name: t.header.aboutMenu.faq, path: '/about#faq', icon: <FaQuestionCircle /> },
  ];

  const solutionsDropdown = [
    {
      category: lang === 'fr' ? 'INFRASTRUCTURE' : 'DATA CENTER INFRASTRUCTURE',
      items: [
        { name: lang === 'fr' ? 'Serveurs' : 'Servers', path: '/solutions/serveur' },
        { name: lang === 'fr' ? 'Stockage' : 'Storage', path: '/solutions/stockage' },
        { name: 'Switching', path: '/solutions/switching' },
        { name: 'Solution HCI', path: '/solutions/hci' },
        { name: 'Backup', path: '/solutions/backup' },
      ],
    },
    {
      category: lang === 'fr' ? 'CLOUD & SÉCURITÉ' : 'CLOUD & SECURITY',
      items: [
        { name: 'Cloud Computing', path: '/solutions/cloud-computing' },
        { name: lang === 'fr' ? 'Cyber Sécurité' : 'Cyber Security', path: '/solutions/cybersecurity' },
        { name: 'Firewall', path: '/solutions/firewall' },
        { name: 'WAF', path: '/solutions/waf' },
        { name: 'Load Balancer', path: '/solutions/load-balancer' },
        { name: 'Antivirus & Anti-Spam', path: '/solutions/antispam-antivirus' },
      ],
    },
    {
      category: lang === 'fr' ? 'RÉSEAU' : 'NETWORK',
      items: [
        { name: 'Core Switching', path: '/solutions/core-switching' },
        { name: 'Access Switching', path: '/solutions/access-switching' },
        { name: 'WiFi & Access Point', path: '/solutions/access-point-wifi' },
        { name: lang === 'fr' ? 'Contrôleur WiFi' : 'WiFi Controller', path: '/solutions/controller-wifi' },
      ],
    },
    {
      category: lang === 'fr' ? 'AFFICHAGE' : 'DIGITAL SIGNAGE',
      items: [
        { name: lang === 'fr' ? "Mur d'écrans" : "Video Wall", path: '/solutions/murs-ecrans' },
        { name: 'Digital Signage', path: '/solutions/digital-signage' },
      ],
    },
    {
      category: lang === 'fr' ? "GESTION D'IMPRESSION" : "PRINT MANAGEMENT",
      items: [
        { name: lang === 'fr' ? "Solutions d'impression" : "Print management solution", path: '/solutions/print-management' },
      ],
    },
  ];

  const servicesDropdown = [
    {
      category: t.header.categories.analyse,
      items: [
        { name: lang === 'fr' ? "Diagnostic & Audit" : "Diagnostic & Audit", path: '/services/analyse-conseil' },
        { name: lang === 'fr' ? "Conseil IT" : "IT Consulting", path: '/services/analyse-conseil#conseil' },
      ],
    },
    {
      category: t.header.categories.impl,
      items: [
        { name: lang === 'fr' ? 'Déploiement' : 'Deployment', path: '/services/implementation-support' },
        { name: lang === 'fr' ? 'Support Technique' : 'Technical Support', path: '/services/implementation-support#support' },
      ],
    },
  ];

  return (
    <header className="sticky-top shadow-sm bg-white" style={{ zIndex: 2000 }}>
      <div className="header-main d-flex flex-column flex-lg-row align-items-stretch" style={{ background: '#fff', borderBottom: '1.5px solid #e0e0e0', minHeight: isDesktop ? 120 : 'auto' }}>
        
        {/* LOGOS GAUCHE (S2I + LOGO LANGUE) */}
        <div className="d-flex justify-content-between align-items-center px-3 py-2 py-lg-0" style={{ minWidth: isDesktop ? 320 : '100%' }}>
          <Link to="/" className="d-flex align-items-center gap-2">
            <img src="/images/logo.png" alt="S2I Logo" style={{ width: isDesktop ? 150 : 100, objectFit: 'contain' }} />
            <img src={langLogo} alt="Experience" style={{ width: isDesktop ? 100 : 70, objectFit: 'contain' }} />
          </Link>
          
          <div className="d-lg-none d-flex align-items-center gap-2">
            <div className="bg-light rounded-pill px-2 py-1 border d-flex" style={{ fontSize: '0.8rem' }}>
              <span onClick={() => switchLanguage('fr')} className={`px-1 cursor-pointer ${lang === 'fr' ? 'text-danger fw-bold' : 'text-muted'}`}>FR</span>
              <span className="text-muted">|</span>
              <span onClick={() => switchLanguage('en')} className={`px-1 cursor-pointer ${lang === 'en' ? 'text-danger fw-bold' : 'text-muted'}`}>EN</span>
            </div>
            <button className="btn border-0 p-1" onClick={() => setExpanded(!expanded)}>
              <FaBars size={24} />
            </button>
          </div>
        </div>

        <div className="flex-grow-1 d-flex flex-column justify-content-between">
          {/* TOP BAR DESKTOP (Inchangée) */}
          <div className="d-none d-lg-flex align-items-center justify-content-center py-2" style={{ borderBottom: '1px solid #e5e5e5', minHeight: 48 }}>
            <Nav className="align-items-center" style={{ gap: '1.5rem', fontSize: '1.05rem', fontWeight: 600 }}>
              <Nav.Link as={Link} to="/" style={{ color: '#3a3a3a' }}>{t.header.group}</Nav.Link>
              <Nav.Link as={Link} to="/#contact" style={{ color: '#3a3a3a' }} onClick={() => handleScrollToSection('/#contact')}>{t.header.contact}</Nav.Link>
              <span className="d-flex align-items-center" style={{ color: '#667eea' }}>
                <FaPhoneAlt className="me-2" /> 
                <span style={{ color: '#3a3a3a' }}>+216 70 839 470</span>
              </span>
              <div className="ms-2 d-flex align-items-center bg-light rounded-pill px-2 py-1" style={{ border: '1px solid #e0e0e0' }}>
                <button onClick={() => switchLanguage('fr')} style={{ border: 'none', background: 'none', fontSize: '0.9rem', fontWeight: lang === 'fr' ? '800' : '500', color: lang === 'fr' ? '#d90000' : '#888', cursor: 'pointer', padding: '0 5px' }}>FR</button>
                <span style={{ color: '#ccc', fontSize: '0.8rem' }}>|</span>
                <button onClick={() => switchLanguage('en')} style={{ border: 'none', background: 'none', fontSize: '0.9rem', fontWeight: lang === 'en' ? '800' : '500', color: lang === 'en' ? '#d90000' : '#888', cursor: 'pointer', padding: '0 5px' }}>EN</button>
              </div>
              <a href="https://tn.linkedin.com/company/s2i-group" target="_blank" rel="noopener noreferrer" className="btn btn-linkedin px-3 py-1" style={{ background: '#0077b5', color: '#fff', borderRadius: 20, fontSize: '0.9rem' }}>
                <FaLinkedin className="me-2" /> LinkedIn
              </a>
            </Nav>
          </div>

          {/* MAIN NAVBAR (Inchangée) */}
          <Navbar expand="lg" expanded={expanded} className="py-0 border-0">
            <Container fluid>
              <Navbar.Collapse>
                <Nav className="mx-auto text-center" style={{ gap: isDesktop ? '2rem' : '1rem', fontWeight: 600, fontSize: '1.08rem', alignItems: 'center' }}>
                  <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>{t.header.home}</Nav.Link>

                  <div className="dropdown-wrapper w-100" onMouseEnter={() => isDesktop && setOpenDropdown('about')} onMouseLeave={() => isDesktop && setOpenDropdown(null)}>
                    <NavDropdown title={t.header.about} show={openDropdown === 'about'} onToggle={(s) => handleToggle(s, 'about')}>
                      <div className="about-menu">
                        {aboutDropdown.map(item => (
                          <NavDropdown.Item as={Link} to={item.path} key={item.name} className="about-item" onClick={() => handleScrollToSection(item.path)}>
                            <span className="about-item-icon">{item.icon}</span>
                            <span>{item.name}</span>
                          </NavDropdown.Item>
                        ))}
                      </div>
                    </NavDropdown>
                  </div>

                  <div className="dropdown-wrapper w-100" onMouseEnter={() => isDesktop && setOpenDropdown('solutions')} onMouseLeave={() => isDesktop && setOpenDropdown(null)}>
                    <NavDropdown title={t.header.solutions} id="solutions-dropdown" show={openDropdown === 'solutions'} onToggle={(s) => handleToggle(s, 'solutions')}>
                      <div className="solutions-mega-menu">
                        {solutionsDropdown.map((cat) => (
                          <div key={cat.category} className="solution-category">
                            <div className="category-header">{cat.category}</div>
                            {cat.items.map(item => (
                              <NavDropdown.Item as={Link} to={item.path} key={item.name} className="solution-item" onClick={() => {setOpenDropdown(null); setExpanded(false)}}>
                                {item.name}
                              </NavDropdown.Item>
                            ))}
                          </div>
                        ))}
                        <div className="solution-image-container d-none d-lg-flex align-items-center justify-content-center">
                          <img src="/images/platinum.png" alt="Dell Platinum" className="solution-showcase-image" />
                        </div>
                      </div>
                    </NavDropdown>
                  </div>

                  <div className="dropdown-wrapper w-100" onMouseEnter={() => isDesktop && setOpenDropdown('services')} onMouseLeave={() => isDesktop && setOpenDropdown(null)}>
                    <NavDropdown title={t.header.services} id="services-dropdown" show={openDropdown === 'services'} onToggle={(s) => handleToggle(s, 'services')}>
                      <div className="services-mega-menu">
                        {servicesDropdown.map((cat) => (
                          <div key={cat.category} className="service-category">
                            <div className="category-header">{cat.category}</div>
                            {cat.items.map(item => (
                              <NavDropdown.Item as={Link} to={item.path} key={item.name} className="service-item-new" onClick={() => handleScrollToSection(item.path)}>
                                {item.name}
                              </NavDropdown.Item>
                            ))}
                          </div>
                        ))}
                      </div>
                    </NavDropdown>
                  </div>

                  <Nav.Link as={Link} to="/news" className="d-flex align-items-center" onClick={() => setExpanded(false)}>
                    {t.header.news}
                    <span className="news-dot"></span>
                  </Nav.Link>

                  {!isDesktop && (
                    <div className="mt-4 pt-3 border-top w-100 text-center">
                       <p className="mb-2 fw-bold small text-muted"><FaPhoneAlt className="me-2" /> +216 70 839 470</p>
                       <a href="https://linkedin.com" className="btn btn-sm btn-primary rounded-pill mb-3 px-4"><FaLinkedin className="me-2"/>LinkedIn</a>
                       <div style={{ height: 60, position: 'relative', display: 'flex', justifyContent: 'center' }}>
                         <img src={partners[partnerIndex].src} alt="partner" style={{ width: 100, objectFit: 'contain' }} />
                       </div>
                    </div>
                  )}
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>

        {/* LOGOS PARTENAIRES DROITE (AVEC ANIMATION) */}
        <div className="d-none d-lg-flex justify-content-center align-items-center" style={{ minWidth: 200, position: 'relative', overflow: 'hidden' }}>
          <AnimatePresence mode="wait">
            <motion.img
              key={partnerIndex}
              src={partners[partnerIndex].src}
              alt={partners[partnerIndex].name}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.5 }}
              style={{ width: 140, objectFit: 'contain', position: 'absolute' }}
            />
          </AnimatePresence>
        </div>
      </div>

      <style>{`
        .cursor-pointer { cursor: pointer; }
        .dropdown-wrapper .dropdown-menu {
          position: absolute !important; top: 100% !important; z-index: 1050;
          border: 1px solid #e0e0e0; border-radius: 12px; box-shadow: 0 8px 32px rgba(0,0,0,0.15); background: white; padding: 10px 0;
        }
        #solutions-dropdown + .dropdown-menu { left: -220px !important; }
        #services-dropdown + .dropdown-menu { left: -100px !important; }
        .about-item, .solution-item, .service-item-new { font-size: 0.85rem !important; padding: 6px 12px !important; display: flex !important; align-items: center; transition: 0.2s; }
        .category-header { font-weight: 700; color: #d90000; font-size: 0.75rem; margin-bottom: 6px; padding: 3px 8px; background: white; border-radius: 6px; border-left: 3px solid #d90000; text-transform: uppercase; }
        .about-item-icon { margin-right: 12px; font-size: 1rem; }
        .about-menu { padding: 10px; min-width: 240px; }
        .about-item:hover, .solution-item:hover, .service-item-new:hover { background: #d90000 !important; color: white !important; transform: translateX(4px); }
        .solutions-mega-menu { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; padding: 15px; min-width: 720px; }
        .services-mega-menu { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; padding: 15px; min-width: 500px; }
        .solution-category, .service-category { background: #f8f9fa; border-radius: 8px; padding: 10px; border: 1px solid #e9ecef; }
        .solution-image-container { background: #fff; border-radius: 8px; padding: 5px; }
        .solution-showcase-image { width: 100%; max-width: 150px; height: auto; object-fit: contain; }
        .news-dot { width: 7px; height: 7px; background-color: #d90000; border-radius: 50%; margin-left: 6px; box-shadow: 0 0 5px rgba(217,0,0,0.5); }
        @media (max-width: 991px) {
          .dropdown-wrapper .dropdown-menu { position: static !important; box-shadow: none; background: #f8f9fa; margin: 10px 0; border: none; width: 100%; }
          .solutions-mega-menu, .services-mega-menu { display: block; min-width: auto; padding: 0; }
          .solution-category, .service-category { background: transparent; border: none; padding: 0; margin-bottom: 15px; }
          .navbar-collapse { background: white; padding: 20px 0; max-height: 80vh; overflow-y: auto; }
        }
      `}</style>
    </header>
  );
};

export default Header;